export const getFeedMessageQueryKey = (id: string) => ['feedMessages', id];
